import { MouseEventHandler, useContext } from 'react';
import styled, { useTheme } from 'styled-components';
import Button from './ui/Button';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import ImageWrapper from './ImageWrapper';
import {
  SearchContext,
  SearchContextInterface
} from '../features/search-new/context/SearchContext';
import { SearchFiltersActionTypes } from '../reducers/search-filters/actions';
import { updateQuery } from '../helpers/common';
import { useSelector } from 'react-redux';
import { SearchViewTypes } from '../new-lib/constants/common';

type NoResultsProps = {
  isResetButton?: boolean;
  onClick?: MouseEventHandler;
};

const NoResultsIndicator = ({ onClick, isResetButton }: NoResultsProps) => {
  const router = useRouter();
  const { t } = useTranslation('common');
  const theme = useTheme();
  const { searchFiltersState, appliedFiltersCount, searchFiltersDispatch } =
    useContext(SearchContext) as SearchContextInterface;

  const getButton = () => {
    const resetFilters = () => {
      searchFiltersDispatch({ type: SearchFiltersActionTypes.RESET });
      if (router.query?.view === SearchViewTypes.MAP) {
        updateQuery(router, undefined, [], true);
      }
    };

    if (isResetButton) {
      return (
        <>
          <p className="text-1">{t('try_adjusting_filters')}</p>
          {(appliedFiltersCount > 0 ||
            searchFiltersState.searchFilters.areas.length > 0 ||
            searchFiltersState.searchFilters.developers.length > 0) && (
            <Button
              backgroundColor={theme.light.colors.primaryBlue}
              border="none"
              color={theme.light.colors.white}
              fontSize={theme.font.sizes.m}
              padding="8px 16px"
              text={t('reset_filters')}
              backgroundHover={theme.light.hoverColors.primaryBlue}
              onClick={onClick ? onClick : resetFilters}
            />
          )}
        </>
      );
    } else {
      return (
        <>
          <p className="text-1">{t('check_another_comopund')}</p>
          <Button
            backgroundColor={theme.light.colors.primaryBlue}
            border="none"
            color={theme.light.colors.white}
            fontSize={theme.font.sizes.m}
            padding="8px 16px"
            text={t('search')}
            backgroundHover={theme.light.hoverColors.primaryBlue}
            onClick={onClick ? onClick : () => {}}
          />
        </>
      );
    }
  };

  return (
    <MainContainer>
      <ImageWrapper
        src={'/assets/images/common/no-results.webp'}
        width={183}
        height={88}
        alt="No Results Icon"
      />

      <h2 className="headline-2">{t('no_results_to_show')}</h2>

      {router.asPath != '/favorites' ? getButton() : ''}
    </MainContainer>
  );
};

const MainContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  height: max-content;
  text-align: center;
  padding: 0 8px;

  .headline-2 {
    font-size: ${props => props.theme.font.sizes.xxxl};
  }

  .text-1 {
    padding-top: 8px;
  }

  button {
    font-family: materialRegular;
    margin-top: 13px;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.tablet.max}) {
    .no-results-gif {
      width: 180px;
    }

    .headline-2 {
      font-size: ${props => props.theme.font.sizes.l};
    }
  }
`;
export default NoResultsIndicator;
